const depots = {
  'netherlands': {
    value: 'netherlands',
    name: 'Netherlands',
    isHeader: true,
    countryCode: 'NLD',
    rentalDepot: false,
    phoneNumber: '+31 77 204 3320'
  },
  'pno-venlo': {
    value: 'pno-venlo',
    name: 'Venlo - PNO',
    isHeader: false,
    address: 'Horsterweg 74c\n5971 NG Grubbenvorst',
    countryCode: 'NLD',
    country: 'Netherlands',
    city: 'Grubbenvorst',
    lat: 51.42654,
    long: 6.103047,
    rentalDepot: true,
  },
  'sweden': {
    value: 'sweden',
    name: 'Sweden',
    isHeader: true,
    countryCode: 'SWE',
    rentalDepot: false,
    phoneNumber: '+46 42 499 15 50'
  },
  'ips-malmo': {
    value: 'ips-malmo',
    name: 'Malmö - IPS AB',
    isHeader: false,
    address: 'Lodgatan 20\n211 24 Malmö',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Malmö',
    lat: 55.623385,
    long: 13.013259,
    rentalDepot: true,
    phoneNumber: '+46722541555',
  },
  'logs-borlange': {
    value: 'logs-borlange',
    name: 'Borlänge - Logs Logistics',
    isHeader: false,
    address: 'Mästargatan 13\n781 71 Borlänge',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Borlänge',
    lat: 60.4717803,
    long: 15.4281365,
    rentalDepot: false,
  },
  'pno-helsingborg': {
    value: 'pno-helsingborg',
    name: 'Helsingborg - IPS AB',
    isHeader: false,
    address: 'Stenbrovägen 48\n253 68 Helsingborg',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Helsingborg',
    lat: 56.0100017,
    long: 12.7770877,
    rentalDepot: true,
    phoneNumber: '+46424991560',
  },
  'ros-jonkoping': {
    value: 'ros-jonkoping',
    name: 'Jönköping - Rosenlunds Verkstad',
    isHeader: false,
    address: 'Lampvägen 6\n556 52 Jönköping',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Jönköping',
    lat: 57.66851920000001,
    long: 14.1627813,
    rentalDepot: true,
    phoneNumber: '+46760008068',
  },
  'save-goteborg': {
    value: 'save-goteborg',
    name: 'Göteborg - Säve',
    isHeader: false,
    address: 'Nya Bergets Väg\n417 46 Göteborg',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Göteborg',
    lat: 57.77604,
    long: 11.88733,
    rentalDepot: false,
  },
  'stj-akersstyckebruk': {
    value: 'stj-akersstyckebruk',
    name: 'Åkers Styckebruk - Stjärnströms trailer service',
    isHeader: false,
    address: 'Logvägen 1\n647 50 Åkers styckebruk',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Åkers styckebruk',
    lat: 59.264397,
    long: 17.108665,
    rentalDepot: true,
    phoneNumber: '+46704859155',
  },
  'sts-gothenburg': {
    value: 'sts-gothenburg',
    name: 'Göteborg - Team Verkstad',
    isHeader: false,
    address: 'Transportgatan 7\n422 46 Hisings backa',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Hisings backa',
    lat: 57.764618,
    long: 11.993699,
    rentalDepot: true,
    phoneNumber: '+4631586180',
  },
  'sts-lulea': {
    value: 'sts-lulea',
    name: 'Luleå - Team Verkstad',
    isHeader: false,
    address: 'Besiktningsvägen 6\n973 45 Luleå',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Luleå',
    lat: 65.620655,
    long: 22.043988,
    rentalDepot: true,
    phoneNumber: '+46920254180',
  },
  'sts-malmo': {
    value: 'sts-malmo',
    name: 'Malmö - Team Verkstad',
    isHeader: false,
    address: 'Terminalgatan 5\n211 24 MALMÖ',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'MALMÖ',
    lat: 55.6214072,
    long: 13.0131114,
    rentalDepot: true,
    phoneNumber: '+46406747910',
  },
  'sts-orebro': {
    value: 'sts-orebro',
    name: 'Örebro - Team Verkstad',
    isHeader: false,
    address: 'Berglundavägen 11\n702 36 Örebro',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Örebro',
    lat: 59.237204,
    long: 15.136624,
    rentalDepot: true,
    phoneNumber: '+4619196880',
  },
  'team-trailerservice-helsingborg': {
    value: 'team-trailerservice-helsingborg',
    name: 'Helsingborg - Team Trailerservice i Skåne AB',
    isHeader: false,
    address: 'Torbornavägen 17\n253 68 ',
    countryCode: 'SWE',
    country: 'Sweden',
    city: '',
    lat: 56.0056549,
    long: 12.7723558,
    rentalDepot: false,
    phoneNumber: '+4642290020',
  },
  'trailermekanik-goteborg': {
    value: 'trailermekanik-goteborg',
    name: 'Göteborg - Trailermekanik i Göteborg AB',
    isHeader: false,
    address: 'Laxfiskevägen 8\n433 38 Partille',
    countryCode: 'SWE',
    country: 'Sweden',
    city: 'Partille',
    lat: 57.7444948,
    long: 12.1249782,
    rentalDepot: false,
    phoneNumber: '+46762984509',
  },
  'finland': {
    value: 'finland',
    name: 'Finland',
    isHeader: true,
    countryCode: 'FIN',
    rentalDepot: false,
    phoneNumber: '+358 9 3434480'
  },
  '018facb7-2835-7e70-87cd-3980e6d3fcff': {
    value: '018facb7-2835-7e70-87cd-3980e6d3fcff',
    name: 'Raskone Airport - Tuusula',
    isHeader: false,
    address: 'Sulankaari\n Hyrylä',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Hyrylä',
    lat: 60.3754831,
    long: 25.0358616,
    rentalDepot: false,
    phoneNumber: '+358102320217',
  },
  '018facc0-19b0-70a8-99aa-e245264ad0fa': {
    value: '018facc0-19b0-70a8-99aa-e245264ad0fa',
    name: 'EK-Wash Oy',
    isHeader: false,
    address: 'Keravantie 507\n ',
    countryCode: 'FIN',
    country: 'Finland',
    city: '',
    lat: 60.3796831,
    long: 25.1866083,
    rentalDepot: false,
    phoneNumber: '+358405188336',
  },
  '019d1a8a-f997-7a70-86ee-b58ada929b26': {
    value: '019d1a8a-f997-7a70-86ee-b58ada929b26',
    name: 'EK-WASH JÄRVENPÄÄ',
    isHeader: false,
    address: 'Halkiantie\n04410 Järvenpää',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Järvenpää',
    lat: 60.5026781,
    long: 25.1184275,
    rentalDepot: true,
    phoneNumber: '',
  },
  'ahl-vahdontie': {
    value: 'ahl-vahdontie',
    name: 'Vahdontie - Ahlqvist Services',
    isHeader: false,
    address: 'Vahdontie 163\n21290 Rusko',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Rusko',
    lat: 60.5107381,
    long: 22.2311628,
    rentalDepot: true,
    phoneNumber: '+358400827936',
  },
  'autokylma-helsingin': {
    value: 'autokylma-helsingin',
    name: 'Helsinki - Helsingin Autokylmä Oy',
    isHeader: false,
    address: 'Rahtarinkatu 1\n00980 Helsinki',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Helsinki',
    lat: 60.2237289,
    long: 25.1691282,
    rentalDepot: false,
    phoneNumber: '+358401310900',
  },
  'box-vantaa': {
    value: 'box-vantaa',
    name: 'Vantaa - Boxfix',
    isHeader: false,
    address: 'Linjatie 5\n01260 Vantaa',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Vantaa',
    lat: 60.2997817,
    long: 25.1003834,
    rentalDepot: false,
    phoneNumber: '+358103229892',
  },
  'dhollandia-sipoo': {
    value: 'dhollandia-sipoo',
    name: 'Sipoo - Dhollandia Oy',
    isHeader: false,
    address: 'Keuksuontie 16\n04220 ',
    countryCode: 'FIN',
    country: 'Finland',
    city: '',
    lat: 60.38043130000001,
    long: 25.1669633,
    rentalDepot: false,
    phoneNumber: '+358942475682',
  },
  'ekeri-finland': {
    value: 'ekeri-finland',
    name: 'Kolppi - Ab Ekeri Oy',
    isHeader: false,
    address: 'Kållbyvägen 1276\n68800 ',
    countryCode: 'FIN',
    country: 'Finland',
    city: '',
    lat: 63.6317759,
    long: 22.9298248,
    rentalDepot: false,
    phoneNumber: '+35867887400',
  },
  'pno-sipoo': {
    value: 'pno-sipoo',
    name: 'Sipoo - PNO',
    isHeader: false,
    address: 'Keravantie 507\n04150 Martinkylä',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Martinkylä',
    lat: 60.38216,
    long: 25.177614,
    rentalDepot: true,
    phoneNumber: '+3583434480',
  },
  'skl-vantaa': {
    value: 'skl-vantaa',
    name: 'Vantaa - Suomen Kuljetuslaite Oy',
    isHeader: false,
    address: 'Hakkilankaari 4\n01380 Vantaa',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Vantaa',
    lat: 60.30032405,
    long: 25.09166870854505,
    rentalDepot: false,
    phoneNumber: '+35810650300',
  },
  'vak-vahto': {
    value: 'vak-vahto',
    name: 'Vahto - VAK',
    isHeader: false,
    address: 'Paattistentie 57\n21310 ',
    countryCode: 'FIN',
    country: 'Finland',
    city: '',
    lat: 60.6155953,
    long: 22.32062419999999,
    rentalDepot: true,
    phoneNumber: '+358207656300',
  },
  'vak-vantaa': {
    value: 'vak-vantaa',
    name: 'Vantaa - VAK Huoltopalvelut Oy',
    isHeader: false,
    address: 'Suokallionkuja 5\n01740 Vantaa',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Vantaa',
    lat: 60.3068685,
    long: 24.8896416,
    rentalDepot: false,
    phoneNumber: '+358207656420',
  },
  'vta-vantaa': {
    value: 'vta-vantaa',
    name: 'Vantaa - VTA Tekniikka OY',
    isHeader: false,
    address: 'Lumijälki, 01690 Vantaa, Finland\n01690 Vantaa',
    countryCode: 'FIN',
    country: 'Finland',
    city: 'Vantaa',
    lat: 60.29232749999999,
    long: 24.9309166,
    rentalDepot: true,
    phoneNumber: '+358105508240',
  },
  'denmark': {
    value: 'denmark',
    name: 'Denmark',
    isHeader: true,
    countryCode: 'DNK',
    rentalDepot: false,
    phoneNumber: '+45 86 51 01 00'
  },
  '018facb5-fb36-77f8-9bec-073e9cc8e68d': {
    value: '018facb5-fb36-77f8-9bec-073e9cc8e68d',
    name: 'DSV Workshop - Horsens Dk',
    isHeader: false,
    address: 'Silkeborgvej 140\n8700 Horsens',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Horsens',
    lat: 55.890761,
    long: 9.775525000000016,
    rentalDepot: false,
    phoneNumber: '+4525452396',
  },
  'bk-padborg': {
    value: 'bk-padborg',
    name: 'Padborg - B&K Service A/S',
    isHeader: false,
    address: 'Plantagevej 3\n6330 Padborg',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Padborg',
    lat: 54.841995,
    long: 9.351738,
    rentalDepot: false,
    phoneNumber: '+4574670200',
  },
  'dn-koge': {
    value: 'dn-koge',
    name: 'Køge - DN Autoservice',
    isHeader: false,
    address: 'Værftsvej 4D\n4600 Køge',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Køge',
    lat: 55.4614827,
    long: 12.1928193,
    rentalDepot: false,
    phoneNumber: '+4556651020',
  },
  'ips-padborg': {
    value: 'ips-padborg',
    name: 'Padborg - IPS',
    isHeader: false,
    address: 'Thorsvej 11\n6330 Padborg',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Padborg',
    lat: 54.8296533,
    long: 9.3401552,
    rentalDepot: false,
    phoneNumber: '+4569156330',
  },
  'jls-tilst': {
    value: 'jls-tilst',
    name: 'Tilst - JLS Aps',
    isHeader: false,
    address: 'Trueholmvej 8\n8381 Tilst',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Tilst',
    lat: 56.178105,
    long: 10.09324,
    rentalDepot: true,
    phoneNumber: '+4570222044',
  },
  'kho-albertslund': {
    value: 'kho-albertslund',
    name: 'Albertslund - KH Onestop',
    isHeader: false,
    address: 'Holsbjergvej 38\n2620 Albertslund',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Albertslund',
    lat: 55.662598,
    long: 12.339951,
    rentalDepot: true,
    phoneNumber: '+4543632444',
  },
  'kho-brondby': {
    value: 'kho-brondby',
    name: 'Brøndby - KH Onestop',
    isHeader: false,
    address: 'Vallensbækvej 34\n2605 Brøndbyvester',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Brøndbyvester',
    lat: 55.643832,
    long: 12.3848299,
    rentalDepot: false,
    phoneNumber: '+4543253100',
  },
  'kho-padborg': {
    value: 'kho-padborg',
    name: 'KH Onestop Padborg',
    isHeader: false,
    address: 'Hermesvej 8\n6330 Padborg',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Padborg',
    lat: 54.828582,
    long: 9.341171,
    rentalDepot: true,
    phoneNumber: '+4573302580',
  },
  'kro-padborg': {
    value: 'kro-padborg',
    name: 'Padborg - Krone Danmark A/S',
    isHeader: false,
    address: 'Kilen 5\n6330 Padborg',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Padborg',
    lat: 54.854724,
    long: 9.360872,
    rentalDepot: false,
    phoneNumber: '+4573115030',
  },
  'pno-horsens': {
    value: 'pno-horsens',
    name: 'Horsens - PNO',
    isHeader: false,
    address: 'Mossvej 17\n8700 Horsens',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Horsens',
    lat: 55.8851437,
    long: 9.7663793,
    rentalDepot: true,
    phoneNumber: '+4586510100',
  },
  'sch-padborg': {
    value: 'sch-padborg',
    name: 'Padborg - Schmitz Cargobull',
    isHeader: false,
    address: 'Europavej 1\n6330 Padborg',
    countryCode: 'DNK',
    country: 'Denmark',
    city: 'Padborg',
    lat: 54.846591,
    long: 9.351735999999999,
    rentalDepot: false,
    phoneNumber: '+4574674024',
  },
  'norway': {
    value: 'norway',
    name: 'Norway',
    isHeader: true,
    countryCode: 'NOR',
    rentalDepot: false,
    phoneNumber: '+47 21 00 48 00'
  },
  'ats-akershus-tungbilservice': {
    value: 'ats-akershus-tungbilservice',
    name: 'Ytre Enebakk - Akershus Tungbilservice',
    isHeader: false,
    address: 'Landskaugveien 27\n1914 Ytre Enebakk',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Ytre Enebakk',
    lat: 59.76632549999999,
    long: 10.9858579,
    rentalDepot: true,
    phoneNumber: '+4746988500',
  },
  'enger-transport-enebakk': {
    value: 'enger-transport-enebakk',
    name: 'Ytre Enebakk - Enger Transport',
    isHeader: false,
    address: 'Landskaugveien 28\n1914 Ytre Enebakk',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Ytre Enebakk',
    lat: 59.7665018,
    long: 10.9878033,
    rentalDepot: true,
    phoneNumber: '+4740606095',
  },
  'lrn-transport': {
    value: 'lrn-transport',
    name: 'Raufoss - LRN Transport',
    isHeader: false,
    address: 'Kildalvegen 13\n2830 Raufoss',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Raufoss',
    lat: 60.710009,
    long: 10.603488,
    rentalDepot: true,
    phoneNumber: '+4761198180',
  },
  'nts-norsk-tungbilservice': {
    value: 'nts-norsk-tungbilservice',
    name: 'Råde - Norsk Tungbilservice',
    isHeader: false,
    address: 'Mosseveien 60\n1640 Råde',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Råde',
    lat: 59.3586888,
    long: 10.838019,
    rentalDepot: true,
    phoneNumber: '+4791768377',
  },
  'pno-langhus': {
    value: 'pno-langhus',
    name: 'Langhus - IPS',
    isHeader: false,
    address: 'Berghagan 5\n1405 Langhus',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Langhus',
    lat: 59.762683,
    long: 10.836737,
    rentalDepot: true,
    phoneNumber: '+4799099411',
  },
  'rtl-langhus': {
    value: 'rtl-langhus',
    name: 'Langhus - Ramberg Container transport AS',
    isHeader: false,
    address: 'Fugleåsen 5\n1405 Langhus',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Langhus',
    lat: 59.7705151,
    long: 10.8538135,
    rentalDepot: true,
    phoneNumber: '+4732267420',
  },
  'tot-tonerud-transport': {
    value: 'tot-tonerud-transport',
    name: 'Spydeberg - Tonerud Transport',
    isHeader: false,
    address: 'Knapstadveien 3\n1820 Spydeberg',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Spydeberg',
    lat: 59.61945840000001,
    long: 11.0497648,
    rentalDepot: true,
    phoneNumber: '+4747905350',
  },
  'trh-trondheim': {
    value: 'trh-trondheim',
    name: 'Trondheim - Trønderlinjen AS',
    isHeader: false,
    address: 'Øybergvegen 43\n7224 Melhus',
    countryCode: 'NOR',
    country: 'Norway',
    city: 'Melhus',
    lat: 63.324249,
    long: 10.22489,
    rentalDepot: true,
    phoneNumber: '+4795135402',
  },
  'germany': {
    value: 'germany',
    name: 'Germany',
    countryCode: 'DEU',
    isHeader: true,
    address: '',
    rentalDepot: false,
    phoneNumber: '+49 40 239596800'
  },
  '018facbe-c6c9-7ec0-b238-ac107d829a7b': {
    value: '018facbe-c6c9-7ec0-b238-ac107d829a7b',
    name: 'TBS Truck & Bus Service',
    isHeader: false,
    address: 'Molkereistraße 2\n27419 Sittensen',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Sittensen',
    lat: 53.2892918,
    long: 9.5023331,
    rentalDepot: false,
    phoneNumber: '+49428257150',
  },
  '018fcdde-5f63-71b0-a340-6ef8fe53ffe8': {
    value: '018fcdde-5f63-71b0-a340-6ef8fe53ffe8',
    name: 'Truck Service Marl',
    isHeader: false,
    address: 'Neckarstraße 17\n45768 Marl',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Marl',
    lat: 51.65529799999999,
    long: 7.0406549,
    rentalDepot: false,
    phoneNumber: '+4923656993890',
  },
  '01938d0c-6bfd-76dc-9ba5-704351e0bf26': {
    value: '01938d0c-6bfd-76dc-9ba5-704351e0bf26',
    name: 'Erfurt - Lamberet',
    isHeader: false,
    address: 'Am Burgsteig 12\n Amt Wachsenburg',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Amt Wachsenburg',
    lat: 50.8850014,
    long: 10.9280533,
    rentalDepot: false,
    phoneNumber: '+493620278740',
  },
  'duk-dorpen': {
    value: 'duk-dorpen',
    name: 'Dörpen - Dörpener Umschlaggesellschaft für den kombinierten Verkehr mbH (DUK)',
    isHeader: false,
    address: 'Industriestraße 4\n26892 Dörpen',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Dörpen',
    lat: 52.97103,
    long: 7.359801300000001,
    rentalDepot: true,
    phoneNumber: '+4949639117500',
  },
  'frankfurt-nord': {
    value: 'frankfurt-nord',
    name: 'Frankfurt Nord - Truck Service A 45 GmbH',
    isHeader: false,
    address: 'Zum Haarstrauch, 63546 Hammersbach, Germany\n63546 Hammersbach',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Hammersbach',
    lat: 50.24835059999999,
    long: 9.0009838,
    rentalDepot: false,
    phoneNumber: '+4960537068144',
  },
  'freiburg-breisgau': {
    value: 'freiburg-breisgau',
    name: 'Freiburg (Breisgau) - Rolf Bauer',
    isHeader: false,
    address: 'Industriestr. 1\n79194 Gundelfingen',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Gundelfingen',
    lat: 48.036938,
    long: 7.863721,
    rentalDepot: false,
    phoneNumber: '+49761582980',
  },
  'haiger': {
    value: 'haiger',
    name: 'Haiger - Scania',
    isHeader: false,
    address: 'Herrenrain 2\n35708 Haiger',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Haiger',
    lat: 50.7626559,
    long: 8.155453099999999,
    rentalDepot: false,
    phoneNumber: '+49277392020',
  },
  'herzlake': {
    value: 'herzlake',
    name: 'Herzlake - Krone',
    isHeader: false,
    address: 'Boschstraße 26\n49770 Herzlake',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Herzlake',
    lat: 52.69287,
    long: 7.59827,
    rentalDepot: false,
  },
  'hof': {
    value: 'hof',
    name: 'Plauen - Auto Müller GmbH & Co. KG',
    isHeader: false,
    address: 'Obermarxgrüner Straße 30\n08527 Plauen',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Plauen',
    lat: 50.45369719999999,
    long: 12.1688754,
    rentalDepot: true,
    phoneNumber: '+4937417197768',
  },
  'kogel-burtenbach': {
    value: 'kogel-burtenbach',
    name: 'Kögel Trailer GmbH',
    isHeader: false,
    address: 'Am Kögel-Werk 1\n89349 Burtenbach',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Burtenbach',
    lat: 48.3472804,
    long: 10.4548134,
    rentalDepot: false,
  },
  'koln': {
    value: 'koln',
    name: 'Köln - Transport & Service Lenicker',
    isHeader: false,
    address: 'Max-Planck-Straße 28\n50354 Hürth',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Hürth',
    lat: 50.88495,
    long: 6.907839999999965,
    rentalDepot: true,
    phoneNumber: '+4922339497720',
  },
  'kro-werlte': {
    value: 'kro-werlte',
    name: 'Werlte - Fahrzeugwerk Bernard Krone',
    isHeader: false,
    address: 'Rudolf-Diesel-Straße 5-7\n48157 Münster',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Münster',
    lat: 51.99179,
    long: 7.66594,
    rentalDepot: false,
  },
  'kulmbach': {
    value: 'kulmbach',
    name: 'Kulmbach - Auto Scholz GmbH',
    isHeader: false,
    address: 'Adalbert-Raps-Straße 4\n95326 Kulmbach',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Kulmbach',
    lat: 50.1115787,
    long: 11.4392568,
    rentalDepot: true,
    phoneNumber: '+49922182000',
  },
  'lubtheen': {
    value: 'lubtheen',
    name: 'Lübtheen - Krone',
    isHeader: false,
    address: 'Geschwister-Scholl-Straße 15\n19249 Lübtheen',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Lübtheen',
    lat: 53.29951,
    long: 11.09783,
    rentalDepot: false,
    phoneNumber: '+4938855400',
  },
  'munchen': {
    value: 'munchen',
    name: 'München - TSF Technik Service Feldgeding',
    isHeader: false,
    address: 'Fürstenfelder Straße 7\n85232 Bergkirchen',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Bergkirchen',
    lat: 48.24384990000001,
    long: 11.3712066,
    rentalDepot: true,
    phoneNumber: '+4981319076840',
  },
  'otto-bloetz-brunswick': {
    value: 'otto-bloetz-brunswick',
    name: 'Braunschweig - Artur Blötz GmbH',
    isHeader: false,
    address: 'In den Waashainen 5\n38108 Braunschweig',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Braunschweig',
    lat: 52.309614,
    long: 10.5425081,
    rentalDepot: true,
    phoneNumber: '+4953123580',
  },
  'otto-bloetz-koenigsborn': {
    value: 'otto-bloetz-koenigsborn',
    name: 'Magdeburg - Otto Blötz GmbH',
    isHeader: false,
    address: 'Thälmannstraße 2\n39175 Königsborn',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Königsborn',
    lat: 52.1339301,
    long: 11.7583336,
    rentalDepot: true,
    phoneNumber: '+4939292600',
  },
  'pno-ulm': {
    value: 'pno-ulm',
    name: 'Ulm - Lamberet',
    isHeader: false,
    address: 'Ernst-Abbe-Straße 30\n89079 Ulm',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Ulm',
    lat: 48.3494776,
    long: 9.9335895,
    rentalDepot: true,
    phoneNumber: '+497319461712',
  },
  'sch-altenberge': {
    value: 'sch-altenberge',
    name: 'Altenberge - Schmitz Cargobull',
    isHeader: false,
    address: 'Siemensstraße 50\n48341 Altenberge',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Altenberge',
    lat: 52.0347,
    long: 7.45188,
    rentalDepot: false,
  },
  'tkv-ulm': {
    value: 'tkv-ulm',
    name: 'Regensburg - Bavarian TrailerWorX GmbH',
    isHeader: false,
    address: 'Ernst-Frenzel-Straße 11\n93083 Obertraubling',
    countryCode: 'DEU',
    country: 'Germany',
    city: 'Obertraubling',
    lat: 48.9768594,
    long: 12.1546293,
    rentalDepot: true,
    phoneNumber: '+499401539550',
  },
  'poland': {
    value: 'poland',
    name: 'Poland',
    countryCode: 'POL',
    isHeader: true,
    address: '',
    rentalDepot: false, 
    phoneNumber: '+48 604808225',
  },
  'gerdex-rawa-mazowiecka': {
    value: 'gerdex-rawa-mazowiecka',
    name: 'Rawa Mazowiecka - Gerdex Truck Service - Adrian Kaczmarczyk',
    isHeader: false,
    address: 'Mszczonowska 36\n96-200 Rawa Mazowiecka',
    countryCode: 'POL',
    country: 'Poland',
    city: 'Rawa Mazowiecka',
    lat: 51.7781348,
    long: 20.2704467,
    rentalDepot: true,
    phoneNumber: '+48603099111',
  },
  'transportservice-pol': {
    value: 'transportservice-pol',
    name: 'Gdynia - Transport Service',
    isHeader: false,
    address: 'Hutnicza 16\n81-061 Gdynia',
    countryCode: 'POL',
    country: 'Poland',
    city: 'Gdynia',
    lat: 54.54693990000001,
    long: 18.4744737,
    rentalDepot: false,
    phoneNumber: '+48691441520',
  },
  'turek-slopanowo': {
    value: 'turek-slopanowo',
    name: 'Slopanowo - TUREK & TUREK - Autoryzowany serwis naczep i pojazdów ciężarowych',
    isHeader: false,
    address: 'Słopanowo-Huby, 64-520 Słopanowo, Poland\n64-520 Słopanowo',
    countryCode: 'POL',
    country: 'Poland',
    city: 'Słopanowo',
    lat: 52.674208785529636,
    long: 16.549744754659702,
    rentalDepot: true,
    phoneNumber: '+48612913343',
  },
  'misc': {
    value: 'misc',
    name: 'Misc',
    isHeader: true,
    address: '',
    rentalDepot: false
  },
  'eurodalys-lithuania': {
    value: 'eurodalys-lithuania',
    name: 'Ukmergė - Eurodalys',
    isHeader: false,
    address: 'Ukmergės r.\n20101 Ukmergė',
    countryCode: 'LTU',
    country: 'Lithuania',
    city: 'Ukmergė',
    lat: 55.20454,
    long: 24.87267,
    rentalDepot: false,
  },
  'ugoauto-latvia': {
    value: 'ugoauto-latvia',
    name: 'Rumbula - UGO AUTO SIA',
    isHeader: false,
    address: 'Kaudzīšu iela 32\n2121 Rumbula',
    countryCode: 'LVA',
    country: 'Latvia',
    city: 'Rumbula',
    lat: 56.89208,
    long: 24.24195,
    rentalDepot: false,
  },
  'in-transit': {
    value: 'in-transit',
    name: 'In transit',
    isHeader: false,
    address: '',
    rentalDepot: false
  },
  'other-depot': {
    value: 'other-depot',
    name: 'Other depot',
    isHeader: false,
    address: '',
    rentalDepot: false
  },
  'at-customer': {
    value: 'at-customer',
    name: 'At Customer',
    isHeader: false,
    address: '',
    rentalDepot: false
  }
}

export const DepotsWithHeaders = { ...depots }
export const DepotsWithHeadersList = Object.keys(DepotsWithHeaders).map(depot => DepotsWithHeaders[depot])
export const DepotsList = DepotsWithHeadersList.filter(depot => !depot.isHeader)
export const Depots = DepotsList.reduce((acc, cur) => ({ ...acc, [cur.value]: depots[cur.value] }), {})
export const Depot = function (depot) {
    return Depots[depot] ? Depots[depot].name : depot
}

export const DepotAddress = function (depot) {
    return Depots[depot] ? Depots[depot].address : ''
}

const countryCodesWithCities = []
const countryWithDepots = []

Object.values(depots).forEach(function(depot) {
    if (depot.city !== undefined) {
        var arr = countryCodesWithCities[depot.countryCode] || []
        if (!arr.includes(depot.city)) {
            arr.push(depot.city)
        }
        countryCodesWithCities[depot.countryCode] = arr
    }

    if (depot.rentalDepot) {
        var arr = countryWithDepots[depot.countryCode] || []
        if (!arr.includes(depot.value)) {
            arr.push(depot.value)
        }
        countryWithDepots[depot.countryCode] = arr
    }
 })


const distinctCountryNames = []

Object.values(depots).forEach(function(depot) {
    if (depot.countryCode !== undefined) {
        distinctCountryNames[depot.countryCode] = depot.country
    }
})

let depotCities = Object.keys(distinctCountryNames).map(function(v) {
    return [v, countryCodesWithCities[v]]
})

export const Countries = {
    ...distinctCountryNames
}

export const Cities = [
    new Map(depotCities)
]

export const CountryDepots = countryWithDepots
